import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getStreamConfig } from '../../services/VideoService';
import { StreamConfigResponse } from '../../types/Videos';

function useGetStreamConfig(
  deviceId: string,
  fleetId: string,
  cameraId: string | number,
  VPNStatus: boolean,
  enabled: boolean = true,
): UseQueryResult<StreamConfigResponse> {
  return useQuery(
    ['stream-config', fleetId, deviceId, cameraId, VPNStatus],
    async () => {
      const data = await getStreamConfig(deviceId, fleetId, cameraId, VPNStatus);
      console.log('[stream-config] raw response:', data);
      return data;
    },
    {
      enabled,
      retry: 3,
      retryDelay: 3000,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    },
  );
}

export default useGetStreamConfig;
